import { useState, useEffect } from 'react';
import { getValidDateType, getValidDateValue } from '../utils';
import { ComposedDateMode } from '../enums';

import type { IDateType, IDateValue } from '@/pages/intelligence/types/common';

const DEFAULT_DATE_TYPE: IDateType = 'date';
const DEFAULT_DATE_VALUES: any = {
  date: ['1', '30'],
  month: ['1', '6'],
};

export default function useRangeMonthPicker(config: {
  mode: ComposedDateMode;
  dateType: IDateType;
  dateValue: IDateValue;
  onChange?: (mode: ComposedDateMode, dateType: IDateType, dateValue: IDateValue) => void;
}) {
  const { mode, dateType: dateTypeOutter, dateValue: dateValueOutter, onChange } = config || {};

  // const validDateType =
  //   mode === ComposedDateMode.Relative ? getValidDateType(dateTypeOutter, DEFAULT_DATE_TYPE) : DEFAULT_DATE_TYPE;
  // const validDateValue =
  //   mode === ComposedDateMode.Relative
  //     ? getValidDateValue(dateValueOutter, DEFAULT_DATE_VALUES[validDateType])
  //     : DEFAULT_DATE_VALUES[DEFAULT_DATE_TYPE];
  const validDateType = getValidDateType(dateTypeOutter, DEFAULT_DATE_TYPE);
  const validDateValue =
    mode === ComposedDateMode.Relative
      ? getValidDateValue(dateValueOutter, DEFAULT_DATE_VALUES[validDateType])
      : DEFAULT_DATE_VALUES[validDateType];
  const [dateType, setDateType] = useState<IDateType>(validDateType);
  const [dateValue, setDateValue] = useState<IDateValue>(validDateValue);

  const handleChange = (type: IDateType, value: IDateValue) => {
    setDateType(type);
    setDateValue(value);
    onChange?.(ComposedDateMode.Relative, type, value);
  };

  useEffect(() => {
    if (mode !== ComposedDateMode.Relative) return;
    const validDateType = getValidDateType(dateTypeOutter, DEFAULT_DATE_TYPE);
    const validDateValue = getValidDateValue(dateValueOutter, DEFAULT_DATE_VALUES[validDateType]);
    setDateType(validDateType);
    setDateValue(validDateValue);
  }, [dateTypeOutter, dateValueOutter]);

  return {
    dateType,
    dateValue,
    onChange: handleChange,
  };
}
